export default __webpack_public_path__ + "static/media/trash-open.217fae82.svg";